<script>
    import { _ } from 'svelte-i18n';
    import axios from 'axios';
    import { url } from '../stores/url.js';
    import { roles } from '../stores/roles.js'; 
    import { users } from '../stores/users.js'; 
    import { permissions } from '../stores/permissions.js'; 
    import { swalConfirm } from '../functions/html-helpers.js';
    import { request, getParam } from '../functions/http-helpers.js'
    import { onMount } from 'svelte';

    
    onMount(() => {
        console.log('mount')
        console.log(getParam('user'))
    });
    
</script>



<div class="uk-container">
    <div class="uk-card uk-card-default uk-card-body uk-margin-top">
        <h3>E-Mail link</h3>
    
        <p>z.b. email verifizieren oder pw zurücksetzten, schöner frontend link...</p>
    </div>
</div>